<footer id="sticky-footer" class="footer mt-auto py-3" [ngClass]="domain">
  <div class="container text-center" >
    <small>2020 Copyright &copy; InfoCert</small>
  </div>
</footer>
